import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, Typography, Grid, IconButton } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import { useLazyGetAllProjectRiskQuery } from "store/slices/apis/projectRiskSlice";
import TableComponent from "components/grid";
import CustomPagination from "components/CustomPagination";
import { RxCross2 } from "react-icons/rx";

const RiskPopUp = (props) => {
    const {header, open, handleClose, label, columns } = props;
    const { projectId } = useParams();
    const dispatch = useDispatch();

    const statusMap = {
        "Total Risk": "",
        "Active Risk": "Active",
        "Closed Risk": "Completed",
        "Mitigation List": ""
    };

    const overDueMap = {
        "Overdue Risk": true,
    }

    const imapctMap = {
        "Risk with Scheduled Impact": "Schedule Impact",
        "Risk with Cost Impact": "Cost Impact",
    }

    const status = statusMap[label] || "";

    const [sortOrder, setSortOrder] = useState('desc');
    const [sortBy, setSortBy] = useState('createdDate');
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const [trigger, { data: riskList, isLoading }] = useLazyGetAllProjectRiskQuery();

    useEffect(() => {
        const filters = {
            SortBy: sortBy,
            SortOrder: sortOrder,
            PageNumber: pageNumber,
            PageSize: pageSize,
            ProjectId: projectId,
            Status: status,
            ImpactType: imapctMap[label] || "",
            ShowOverdueOnly: overDueMap[label] || false
        };
        trigger(filters);
    }, [sortBy, sortOrder, pageNumber, pageSize, status, projectId, trigger]);

    const handleRequestSort = (property) => {
        const isAsc = sortBy === property && sortOrder === 'asc';
        setSortOrder(isAsc ? 'desc' : 'asc');
        setSortBy(property);
        setPageNumber(1);
    };

    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
    };

    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageNumber(1);
    };

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: { color: type },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: {
                    borderTopLeftRadius: "5px",
                    borderTopRightRadius: "5px",
                    backgroundColor: "#FFFFFF",
                    width: "100%",
                    overflowX: "hidden"
                }
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #ddd",
                    backgroundColor: "#ECECEC",
                    pb: 2,
                    pt: 3,
                    width: "100%"
                }}
            >
                <Typography
                    sx={{
                        fontWeight: 600,
                        fontSize: "27px",
                        lineHeight: "100%",
                        color: "#140F36",
                        fontFamily: "Outfit, sans-serif"
                    }}
                >
                    {header}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500]
                    })}
                >
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container>
                    <Grid size={{ md: 12 }}>
                        <TableComponent
                            columns={columns}
                            data={riskList?.data || []}
                            createSortHandler={handleRequestSort}
                            loading={isLoading}
                            order={sortOrder}
                            orderBy={sortBy}
                        />
                    </Grid>
                    <Grid size={{ md: 12 }}>
                        <CustomPagination
                            totalCount={riskList?.totalRecords || 0}
                            pageSize={pageSize}
                            page={pageNumber}
                            onPageChange={handlePageChange}
                            setCurrentPage={setPageNumber}
                            onPageSizeChange={handlePageSizeChange}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default RiskPopUp;